import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './AboutPage.css';
import dsbackpic from '../../images/IMG1.jpg';
import Aos from 'aos';
import 'aos/dist/aos.css';
import CountUp from 'react-countup';

function AboutPage(props) {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const handleContactMe = () => {
    window.location.href = 'mailto:sainidhruv1997@gmail.com';
  };


  return (
    <Container className="aboutContainer" id="about">
      <div className="row">
        <div className="col-12 aboutClass">
          <img className="bgImg" data-aos="fade-up" alt="background" src={dsbackpic} />
          <div className="contentLeft" data-aos="fade-up">
            <div className=" text-center coder description">
              <h1>Software Engineer</h1>
              <p>
  Hello! I am a passionate software engineer from India, currently based in the Bay Area, California.
  <br /><br />
  With an insatiable curiosity for technology and an unwavering commitment to solving complex problems, I thrive in designing and implementing scalable software solutions that drive remarkable outcomes.
</p>

              <button className="contactBtn" onClick={handleContactMe}>
                Contact Me
              </button>
            </div>
          </div>
          <div className="contentRight" data-aos="fade-up">
            <div className="countClass">
              <h1>
                <CountUp start={0} end={5} duration={3} delay={0.01} />+
              </h1>
              <h5>Years of Experience</h5>
            </div>
            <div className="whatsNew">
  <h2>What’s New With Me ?</h2>
  <p>
  I’m currently building agentic AI applications at C3.AI — working on LLM integration, RAG pipelines, workflow orchestration with LangGraph, and AI-powered document generation.</p><p>
  Passionate about the intersection of software engineering and artificial intelligence, I love turning complex problems into intelligent, scalable solutions.
  </p>
</div>

<a
  className="downloadBtn"
  href="https://drive.google.com/file/d/1VbZXZRn4VVkoVPnq7rfXg4OorBrAy0iw/view?usp=sharing"
  target="_blank"
  rel="noopener noreferrer"
>
  <div className="countClass downloadClass">
    <p>Open Resume</p>
  </div>
</a>
<div className="mobileDownloadClass">
  <p>
    <a
      className="downloadBtn"
      href="https://drive.google.com/file/d/1VbZXZRn4VVkoVPnq7rfXg4OorBrAy0iw/view?usp=sharing"
      target="_blank"
      rel="noopener noreferrer"
    >
      Open Resume
    </a>
  </p>
</div>

          </div>
        </div>
      </div>
    </Container>
  );
}

export default AboutPage;
